module.exports = __webpack_public_path__ + "media/images/brand/lander/right-iceberg-dc04ae8a77da8dc12ce6df00ed5363ae.svg";